module.exports = __webpack_public_path__ + "img/8.1-sort-order.fb914ad0.png";